import React from 'react';
import { useTranslation } from 'react-i18next';

const Notification = ({ type, message, isVisible, onClose }) => {
  const { i18n } = useTranslation();
  if (!isVisible) return null;

  const notificationStyles = {
    info: {
      border: 'border-signal/40',
      bg: 'bg-sky-wash',
      icon: 'bg-signal/80',
      iconContent: (
        <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
        </svg>
      )
    },
    error: {
      border: 'border-red-400',
      bg: 'bg-red-50',
      icon: 'bg-red-400',
      iconContent: (
        <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
        </svg>
      )
    },
    success: {
      border: 'border-green-400',
      bg: 'bg-green-50',
      icon: 'bg-green-400',
      iconContent: (
        <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
        </svg>
      )
    },
    warning: {
      border: 'border-orange-400',
      bg: 'bg-orange-50',
      icon: 'bg-orange-400',
      iconContent: (
        <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
          <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
        </svg>
      )
    }
  };

  const style = notificationStyles[type] || notificationStyles.info;

  return (
    <div className="fixed top-4 right-4 z-50 max-w-sm w-full">
      <div className={`rounded-lg border ${style.border} ${style.bg} p-4 shadow-lg`}>
        <div className="flex items-center justify-between">
          <div className="flex items-center flex-1">
            <div className={`rounded-full p-1 ${style.icon} mr-2`}>
              {style.iconContent}
            </div>
            <p className={`text-sm font-medium text-gray-800 flex-1 ${i18n.language?.startsWith('en') ? 'text-left ml-2' : 'text-right mr-2'}`} dir={i18n.language?.startsWith('en') ? 'ltr' : 'rtl'}>
              {message}
            </p>
          </div>
          {onClose && (
            <button
              onClick={onClose}
              className="mr-2 text-gray-400 hover:text-gray-600 transition-colors"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Notification; 